"use client";

import { Check } from "lucide-react";
import { lessonKey, useLearnProgress } from "./progress";

/* Lesson number badge on path pages; turns into a tick once marked done.
   "sm" is the quieter outline badge used in the lesson sidebar, where the
   current lesson is the one that gets the gold. */
export default function DoneTick({
  track,
  lesson,
  n,
  size = "md",
  current = false,
}: {
  track: string;
  lesson: string;
  n: number;
  size?: "md" | "sm";
  current?: boolean;
}) {
  const { done } = useLearnProgress();
  const isDone = done.has(lessonKey(track, lesson));
  const label = isDone ? `Lesson ${n}, done` : `Lesson ${n}`;

  if (size === "sm") {
    const filled = isDone || current;
    return (
      <span
        className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border text-[11px] font-bold"
        style={{
          background: filled ? "#ffe500" : "transparent",
          borderColor: filled ? "#ffe500" : "var(--hairline-strong)",
          color: filled ? "#111" : "var(--muted-foreground)",
        }}
        aria-label={label}
      >
        {isDone ? <Check className="h-3.5 w-3.5" aria-hidden /> : n}
      </span>
    );
  }

  return (
    <span
      className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#ffe500] text-[13px] font-bold text-black"
      aria-label={label}
    >
      {isDone ? <Check className="h-4 w-4" aria-hidden /> : n}
    </span>
  );
}
